import ListingSlugField from './ListingSlugField.component';

export default ListingSlugField;